module.exports = __webpack_public_path__ + "static/media/fz_schdviewrobotverified_pt_BR.70d46284.png";